export default "__VITE_ASSET__CAsZ5Rgk__"